import { useMemo, useState } from "react";
import { hotSearch, tickerItems } from "@/mocks/hotData";

const categoryChips = [
  { label: "娱乐瓜", icon: "ri-star-smile-line" },
  { label: "社会热点", icon: "ri-building-2-line" },
  { label: "科技热闻", icon: "ri-cpu-line" },
  { label: "生活潮流", icon: "ri-sparkling-2-line" },
];

export default function Hero() {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);

  const suggestions = useMemo(() => {
    const q = query.trim();
    if (!q) return [];
    return hotSearch.filter((h) => h.title.toLowerCase().includes(q.toLowerCase())).slice(0, 6);
  }, [query]);

  const top3 = hotSearch.slice(0, 3);

  const focus = (title: string) => {
    sessionStorage.setItem("chigua_focus", title);
    setQuery("");
    setOpen(false);
    document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" });
  };

  const goSection = (label: string) => {
    sessionStorage.setItem("chigua_focus", label);
    document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative isolate overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20collage%20of%20trending%20hot%20topics%20with%20speech%20bubbles%2C%20newspaper%20cutouts%2C%20flame%20icons%20and%20confetti%2C%20warm%20cream%20paper%20background%20with%20watermelon%20green%20and%20fire%20orange%20accent%20blocks%2C%20playful%20modern%20minimalist%20editorial%20style%2C%20soft%20geometric%20shapes%2C%20clean%20and%20light%2C%20high%20detail%20abstract%20no%20text&width=1920&height=1080&seq=hero-chigua-2026-x1&orientation=landscape"
          alt="吃瓜热门今日热点聚合门户插画背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/20"></div>
      </div>

      <div className="mx-auto max-w-[1200px] px-4 pb-16 pt-28 md:px-6 md:pt-36 lg:pb-24">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-flashlight-fill"></i>
              全网热点 · 实时聚合
            </span>

            <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-6xl">
              今天，网上
              <span className="relative inline-block text-primary-600">
                都在吃什么瓜
                <span className="absolute -bottom-1 left-0 h-1.5 w-full rounded-full bg-accent-400/70"></span>
              </span>
              ？
            </h1>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
              吃瓜热门把分散在全网的热搜、事件与热点集中到一个页面，按热度或时间一键切换，实时刷新不漏瓜。
              打开第一页，就能标出当下最值得关注的瓜点。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <div className="relative flex-1 max-w-md">
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500"></i>
                <input
                  type="text"
                  value={query}
                  onChange={(e) => {
                    setQuery(e.target.value);
                    setOpen(true);
                  }}
                  onFocus={() => setOpen(true)}
                  onBlur={() => setTimeout(() => setOpen(false), 150)}
                  placeholder="搜索想吃的瓜，如：盛典官宣、夜宵经济"
                  className="h-13 w-full rounded-full border border-background-300 bg-background-50 py-3.5 pl-11 pr-4 text-sm text-foreground-950 outline-none transition focus:border-primary-400 focus:ring-4 focus:ring-primary-100"
                />
                {open && suggestions.length > 0 && (
                  <div className="absolute left-0 right-0 top-full z-30 mt-2 overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-lg">
                    {suggestions.map((s) => (
                      <button
                        key={s.title}
                        type="button"
                        onMouseDown={() => focus(s.title)}
                        className="flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-foreground-800 transition-colors hover:bg-background-100"
                      >
                        <i className="ri-fire-line text-primary-500"></i>
                        <span className="truncate">{s.title}</span>
                        <span className="ml-auto text-xs text-foreground-500">{s.tag}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="flex gap-2">
                {categoryChips.map((c) => (
                  <button
                    key={c.label}
                    type="button"
                    onMouseDown={() => goSection(c.label)}
                    className="whitespace-nowrap rounded-full border border-background-300 bg-background-50/80 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                  >
                    {c.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="mt-8 hidden items-center gap-3 md:flex">
              {tickerItems.slice(0, 3).map((t, i) => (
                <span key={t} className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className={`${i === 0 ? "ri-arrow-up-line text-primary-500" : "ri-time-line text-accent-600"}`}></i>
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-50/90 backdrop-blur">
              <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
                <div className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-primary-500 animate-tickerPulse"></span>
                  <h2 className="text-sm font-bold text-foreground-950">今日最值得关注的瓜点</h2>
                </div>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-flashlight-line text-accent-600"></i>
                  刚刚刷新
                </span>
              </div>
              <ul className="divide-y divide-background-200/80">
                {top3.map((item, i) => (
                  <li key={item.title} className="flex items-start gap-3 px-5 py-4 transition-colors hover:bg-background-100/70">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-black ${
                        i === 0
                          ? "bg-primary-500 text-background-50"
                          : i === 1
                            ? "bg-accent-500 text-background-50"
                            : "bg-secondary-200 text-foreground-800"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate text-sm font-medium text-foreground-950">{item.title}</p>
                      <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                        <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">{item.tag}</span>
                        <span className="flex items-center gap-0.5 text-primary-600">
                          <i className="ri-fire-line"></i>
                          {item.heat} 热度
                        </span>
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
              <a
                href="#hot"
                className="flex items-center justify-center gap-1 border-t border-background-200 bg-background-100/70 py-3 text-xs font-medium text-primary-700 transition-colors hover:text-primary-800"
              >
                查看完整热搜榜
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex items-center gap-4">
          <div className="flex shrink-0 items-center gap-2 rounded-full bg-foreground-950 px-4 py-2 text-xs font-medium text-background-50">
            <i className="ri-record-circle-fill text-accent-400"></i>
            实时滚动
          </div>
          <div className="relative flex-1 overflow-hidden" aria-hidden="true">
            <div className="flex w-max animate-marquee gap-8 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((t, idx) => (
                <span key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-fire-fill text-primary-500"></i>
                  {t}
                </span>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-background-50 to-transparent"></div>
            <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-background-50 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}